import { render, staticRenderFns } from "./addNewCust.vue?vue&type=template&id=4fbe3588&scoped=true&"
import script from "./addNewCust.vue?vue&type=script&lang=js&"
export * from "./addNewCust.vue?vue&type=script&lang=js&"
import style0 from "./addNewCust.vue?vue&type=style&index=0&id=4fbe3588&prod&lang=css&"
import style1 from "./addNewCust.vue?vue&type=style&index=1&id=4fbe3588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe3588",
  null
  
)

export default component.exports